import { AsyncThunkAction } from 'actions/actions.types'
import { fetchMessengerChatAction } from 'actions/messenger/fetchMessengerChatAction'
import { pushToChatAction } from 'actions/messenger/pushToChatAction'
import { ChatEventReasons } from 'actions/messengerStopChat/constants'
import { showStopChatIfNeeded } from 'actions/messengerStopChat/showStopChatIfNeeded'

export const foreignProfileOpenChatAction =
  (profileId: number): AsyncThunkAction =>
  async (dispatch) => {
    await dispatch(fetchMessengerChatAction({ profileId }))

    if (dispatch(showStopChatIfNeeded(ChatEventReasons.ChatOpen))) {
      return // Покажется стопчат
    }

    dispatch(pushToChatAction(profileId))
  }
